export default hashids => (
  window.open(`${process.env.API_LOCATION}/invoices/pdfs/download/?bill_ids=${hashids.join(',')}&token=${localStorage.getItem('id_token')}`)
);



// WEBPACK FOOTER //
// ./src/app/services/invoice/bulkDownload.js